"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var SecureAxiosInstance_1 = tslib_1.__importDefault(require("../auth/SecureAxiosInstance"));
var axiosHeaders = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8' };
var customHeaders = function (customData) {
    var headers = Object.assign({}, axiosHeaders, customData);
    return headers;
};
var BaseApiService = /** @class */ (function () {
    function BaseApiService() {
    }
    BaseApiService.get = function (url, source, customHeader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var axiosPromise, axiosResponse;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        axiosPromise = source ? BaseApiService.getAxiosPromiseWithSource(url, source, customHeader) :
                            BaseApiService.getAxiosPromise(url, customHeader);
                        return [4 /*yield*/, BaseApiService.prepareAxiosResponse(axiosPromise)];
                    case 1:
                        axiosResponse = _a.sent();
                        return [2 /*return*/, BaseApiService.prepareApiResponse(axiosResponse)];
                }
            });
        });
    };
    BaseApiService.post = function (url, payload, source) {
        if (payload === void 0) { payload = ''; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var axiosPromise, axiosResponse;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        axiosPromise = source ? BaseApiService.postAxiosPromiseWithSource(url, payload, source) :
                            BaseApiService.postAxiosPromise(url, payload);
                        return [4 /*yield*/, BaseApiService.prepareAxiosResponse(axiosPromise)];
                    case 1:
                        axiosResponse = _a.sent();
                        return [2 /*return*/, BaseApiService.prepareApiResponse(axiosResponse)];
                }
            });
        });
    };
    BaseApiService.put = function (url, payload) {
        if (payload === void 0) { payload = ''; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var axiosPromise, axiosResponse;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        axiosPromise = BaseApiService.putAxiosPromise(url, payload);
                        return [4 /*yield*/, BaseApiService.prepareAxiosResponse(axiosPromise)];
                    case 1:
                        axiosResponse = _a.sent();
                        return [2 /*return*/, BaseApiService.prepareApiResponse(axiosResponse)];
                }
            });
        });
    };
    BaseApiService.delete = function (url, source, customHeader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var axiosPromise, axiosResponse;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        axiosPromise = source ? BaseApiService.deleteAxiosPromiseWithSource(url, source, customHeader) :
                            BaseApiService.deleteAxiosPromise(url, customHeader);
                        return [4 /*yield*/, BaseApiService.prepareAxiosResponse(axiosPromise)];
                    case 1:
                        axiosResponse = _a.sent();
                        return [2 /*return*/, BaseApiService.prepareApiResponse(axiosResponse)];
                }
            });
        });
    };
    BaseApiService.prepareApiResponse = function (response) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var apiResponse;
            return tslib_1.__generator(this, function (_a) {
                apiResponse = {
                    status: response.status,
                    data: response.data
                };
                return [2 /*return*/, apiResponse];
            });
        });
    };
    BaseApiService.prepareAxiosResponse = function (axiosPromise) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axiosPromise];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(error_1)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BaseApiService.getAxiosPromise = function (url, customHeader) {
        var Axios = SecureAxiosInstance_1.default.Instance;
        return Axios({
            method: "GET",
            headers: customHeader ? customHeaders(customHeader) : axiosHeaders,
            url: url
        });
    };
    BaseApiService.getAxiosPromiseWithSource = function (url, source, customHeader) {
        var Axios = SecureAxiosInstance_1.default.Instance;
        return Axios({
            method: "GET",
            headers: customHeader ? customHeaders(customHeader) : axiosHeaders,
            url: url,
            cancelToken: source.token
        });
    };
    BaseApiService.postAxiosPromise = function (url, payload) {
        if (payload === void 0) { payload = ''; }
        var Axios = SecureAxiosInstance_1.default.Instance;
        return Axios({
            data: payload,
            headers: axiosHeaders,
            method: 'POST',
            url: url
        });
    };
    BaseApiService.postAxiosPromiseWithSource = function (url, payload, source) {
        if (payload === void 0) { payload = ''; }
        var Axios = SecureAxiosInstance_1.default.Instance;
        return Axios({
            data: payload,
            headers: axiosHeaders,
            method: 'POST',
            url: url,
            cancelToken: source.token
        });
    };
    BaseApiService.putAxiosPromise = function (url, payload) {
        var Axios = SecureAxiosInstance_1.default.Instance;
        return Axios({
            data: payload,
            headers: axiosHeaders,
            method: 'PUT',
            url: url
        });
    };
    BaseApiService.deleteAxiosPromise = function (url, customHeader) {
        var Axios = SecureAxiosInstance_1.default.Instance;
        return Axios({
            headers: customHeader ? customHeaders(customHeader) : axiosHeaders,
            method: 'DELETE',
            url: url
        });
    };
    BaseApiService.deleteAxiosPromiseWithSource = function (url, source, customHeader) {
        var Axios = SecureAxiosInstance_1.default.Instance;
        return Axios({
            headers: customHeader ? customHeaders(customHeader) : axiosHeaders,
            method: 'DELETE',
            url: url,
            cancelToken: source.token
        });
    };
    return BaseApiService;
}());
exports.BaseApiService = BaseApiService;
//# sourceMappingURL=BaseApiService.js.map